export var LOGOUT_TIMEOUT = 1000 * 60 * 5;
export var PROMPT_TIMEOUT = 1000 * 60 * 55;
export var ACTIVITY_LOG_INTERVAL = 2000;
export var RECORDING_KEEP_ALIVE_INTERVAL = 1000 * 5;
export var RECORDING_MAX_DURATION = 1000 * 25;

export var EVENTS = [
  "mousemove",
  "keydown",
  "wheel",
  "DOMMouseScroll",
  "mousewheel",
  "mousedown",
  "touchstart",
  "touchmove",
  "MSPointerDown",
  "MSPointerMove",
  "focus",
];
